import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  title: {
    fontFamily: 'Red Hat Display Bold, sans-serif',
    textAlign: 'center',
    fontSize: '22px',
  },
  subTitle: {
    fontFamily: 'Red Hat Display Regular, sans-serif',
    textAlign: 'center',
    fontSize: '18px',
  },
  buttonFilled: {
    width: '300px',
    height: '56px',
    borderRadius: '50px',
    border: 'none',
    backgroundColor: '#5e44ff',
    color: 'white',
    fontWeight: '500',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      fontWeight: 'bolder',
      backgroundColor: '#ef0bef',
      boxShadow: '-7px 7px 0px #000000',
      border: '2px solid #000000',
      borderRadius: '50px',
      opacity: '1',
    },
    '&:disabled': {
      backgroundColor: '#c1c1c1',
      color: '#6e6e6e',
      boxShadow: 'none',
      border: 'none',
      cursor: 'not-allowed',
    },
  },
  buttonOutlined: {
    width: '300px',
    height: '56px',
    borderRadius: '50px',
    border: '2px solid #5e44ff',
    color: '#5e44ff',
    fontWeight: '500',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      fontWeight: 'bolder',
      backgroundColor: '#ffffff',
      borderColor: '#ef0bef',
      color: '#ef0bef',
      borderRadius: '50px',
      opacity: '1',
    },
    //disabled style
    '&:disabled': {
      backgroundColor: '#c1c1c1',
      color: '#6e6e6e',
      boxShadow: 'none',
      border: 'none',
      cursor: 'not-allowed',
    },
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    // For mobile responsiveness
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  container: {
    display: 'flex',
    width: '90%',
    margin: '0 auto',
    maxWidth: '500px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(10),
    gap: theme.spacing(2),
    borderRadius: '50px',
  },
  buttonContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  sisteButtonFilled: {
    borderRadius: '50px',
    padding: '6px 16px',
    border: 'none',
    backgroundColor: '#00369C',
    color: 'white',
    fontWeight: '500',
    fontSize: '14px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#0155E7',
    },
    '&:disabled': {
      backgroundColor: '#B1B0B0',
      color: 'white',
    },
  },
  spanHelperText: {
    fontFamily: 'Red Hat Display Regular, sans-serif',
    fontSize: '12px',
    color: '#C6C6C6',
  },
}))
